import select from 'dom-select';

export const toggle = new Event('toggle', { bubbles: true }); // eslint-disable-line
export const refresh = new Event('refresh', { bubbles: true });

export const Expandable = (el) => {
  const ui = {
    el,
    drawer: select('.expandable__drawer', el),
    toggle: null // defined below, may or may not exist
  };

  const state = {
    startOpen: ui.el.dataset.startOpen === 'true' || false,
    isExpanded: ui.el.dataset.startOpen === 'true' || false,
    closedHeight: ui.el.dataset.closedHeight || 0
  };

  const expandMe = () => {
    const height = ui.drawer.offsetHeight;
    console.log(ui.drawer, ui.drawer.offsetHeight);
    ui.el.style.height = `${height}px`;
    ui.el.classList.add('is-expanded');
    console.log('expand');

    if (ui.toggle) {
      ui.toggle.setAttribute('aria-expanded', true);
    }

    console.log('set att');
    ui.drawer.setAttribute('aria-hidden', false);

    state.isExpanded = true;
  };

  const onToggle = () => {
    console.log('on toggle');
    if (state.isExpanded) {
      ui.el.style.height = state.closedHeight;

      setTimeout(() => {
        ui.el.classList.remove('is-expanded');
      }, 200); // animation time

      if (ui.toggle) {
        ui.toggle.setAttribute('aria-expanded', false);
      }

      ui.drawer.setAttribute('aria-hidden', true);
      state.isExpanded = false;
    } else {
      expandMe();
    }
  };

  const addEventListeners = () => {
    el.addEventListener('toggle', onToggle);
    el.addEventListener('refresh', expandMe);
  };

  const handleExpandableToggle = () => {
    const { id } = ui.el;

    ui.toggle = select(`#toggles-${id}`);

    if (ui.toggle !== null) {
      if (state.isExpanded) {
        ui.toggle.setAttribute('aria-expanded', false);
      }

      ui.toggle.addEventListener('click', () => {
        onToggle();
      });
    } else {
      console.log('no toggle');
    }
  };

  const setStartingHeight = () => {
    if (!state.startOpen) {
      console.log('start closed');
      ui.el.style.height = state.closedHeight;
      ui.drawer.setAttribute('aria-hidden', true);
    } else {
      expandMe();
    }
  };

  const init = () => {
    console.log(state);
    handleExpandableToggle();
    addEventListeners();
    setStartingHeight();
  };

  init();
};

export default Expandable;
